export enum QueryFormat {
  GML2 = 'gml2' as any,
  GML3 = 'gml3' as any,
  JSON = 'json' as any,
  GEOJSON = 'geojson' as any,
  TEXT = 'text' as any,
  HTML = 'html' as any
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/query/shared/query.enum.ts